import * as z from 'zod'

export const campsiteResponseTypeSchema = z.object({
  countryIso: z.string().optional(),
  value: z.string(),
  name: z.string(),
  hierarchyTextShortCountry: z.string(),
  url: z.string(),
  thumb: z.string(),
  tokens: z.string().array(),
})

export const hierarchyResponseTypeSchema = z.object({
  name: z.string(),
  level: z.string(),
  bookable_count: z.string(),
  bookable_count_number: z.number(),
  bookable_string: z.string(),
  country_iso: z.string().optional(),
  url: z.string(),
  type: z.number(),
  search_radius: z
    .string()
    .transform((val) => (val ? Number(val) : undefined))
    .optional(),
})

export const recentSearchResponseTypeSchema = z.object({
  url: z.string(),
  language: z.string(),
  timestamp: z.string(),
  meta: z.object({
    filters: z.record(z.any()),
    search_context: z.record(z.any()),
  }),
  isEmpty: z.boolean().optional(),
})

export type CampsiteResponse = z.infer<typeof campsiteResponseTypeSchema>

export type HierarchyResponse = z.infer<typeof hierarchyResponseTypeSchema>

export type RecentSearchResponse = z.infer<
  typeof recentSearchResponseTypeSchema
>
